import { useRouter } from "next/router";
import type React from "react";
import { useRef } from "react";
import { authPaths, useAuth } from "@medbillai/app/lib/auth";
import { FullscreenSpinner } from "@medbillai/ui";
import { homeUrl, loginUrl } from "@medbillai/utils/urls";
export const AuthGate = (props: {
  children: React.ReactNode;
}) => {
  const {
    isReady,
    isAuthenticated,
    setIntendedPath
  } = useAuth();
  const {
    replace,
    pathname,
    asPath,
    isReady: routerIsReady
  } = useRouter();
  const redirectedRef = useRef(false);
  if (!isReady || !routerIsReady) {
    return <FullscreenSpinner />;
  }
  if (!isAuthenticated) {
    if (!redirectedRef.current) {
      redirectedRef.current = true;

      // Only store paths that aren't auth-related and aren't the home page
      const shouldStorePath = pathname !== "/" && !authPaths.includes(pathname);
      if (shouldStorePath) {
        setIntendedPath(asPath);
      }
      void replace(loginUrl());
    }
    return <FullscreenSpinner />;
  }

  // If authenticated and on an auth page, redirect to home
  if (isAuthenticated && authPaths.includes(pathname)) {
    if (!redirectedRef.current) {
      redirectedRef.current = true;
      void replace(homeUrl());
    }
    return <FullscreenSpinner />;
  }
  return <>{props.children}</>;
};